import { Icon, Title } from "@sicredi/react";
import React, { ReactNode, useState } from "react";
import styles from "./styles.module.scss";
import { ButtonLinkChevronRight } from "../ButtonLinkChevronRight";
import { useNavigate } from "react-router-dom";

interface AccordionProps {
  title: string;
  content: ReactNode;
  textButton?: string;
  linkButton?: string;
  isShowLineTop?: boolean;
  isShowLineBottom?: boolean;
  onClickButton?: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  textButton,
  linkButton,
  isShowLineTop = true,
  isShowLineBottom = true,
  onClickButton,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleButton = () => {
    if (textButton === "Fazer uma simulação") {
      navigate(linkButton ?? "");
    } else {
      window.open(linkButton, "_blank");
    }
  };

  return (
    <div
      className={styles.container}
      style={{
        borderTop: isShowLineTop ? "1px solid #ccc" : "",
        borderBottom: isShowLineBottom ? "1px solid #ccc" : "",
      }}
    >
      <div className={styles.text_icon} onClick={() => setIsOpen(!isOpen)}>
        <Title size="medium" as="h4" weight="semi-bold">
          {title}
        </Title>

        <div
          className={styles.icon_container}
          style={{
            transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)",
          }}
        >
          <Icon name={"chevron-down"} appearance="primary" />
        </div>
      </div>
      {isOpen && (
        <div
          className={styles.content_accordion}
          style={{
            maxHeight: isOpen ? "320px" : "0",
          }}
        >
          {content}

          {textButton && (
            <ButtonLinkChevronRight
              text={textButton}
              onClick={linkButton ? handleButton : onClickButton}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Accordion;
